import { BaseRentalCountry } from 'src/api/types.d'

/**
 * What each country is called on the admin screens that filter by one.
 *
 * The onboarding form does not read this: it takes its list from
 * `signupCountries`, because which countries are open is a commercial rule the
 * server owns. These names must match the ones the server sends, or the same
 * country is called two things on two screens.
 */
const countryNames: Record<BaseRentalCountry, string> = {
  at: 'Austria',
  be: 'Belgium',
  cz: 'Czechia',
  ee: 'Estonia',
  fi: 'Finland',
  fr: 'France',
  de: 'Germany',
  is: 'Iceland',
  lv: 'Latvia',
  lt: 'Lithuania',
  nl: 'Netherlands',
  no: 'Norway',
  pl: 'Poland',
  sk: 'Slovakia',
  ch: 'Switzerland',
  us: 'United States',
}

export default countryNames
